import React from "react";
import { FormattedHTMLMessage } from "react-intl";
import { IconSeat } from "@trainline/depot-web";
import { SeatClass } from "../../types/SeatReservation";
import * as s from "./SeatReservations.module.css";
const NoSeatAssigned = ({ seatClass }) => {
  return /* @__PURE__ */ React.createElement("section", {
    className: s.container
  }, /* @__PURE__ */ React.createElement("section", {
    className: s.icon
  }, /* @__PURE__ */ React.createElement(IconSeat, null)), /* @__PURE__ */ React.createElement(FormattedHTMLMessage, {
    id: seatClass === SeatClass.STANDARD ? "seatReservation.noAssignedSeatsStandardClass" : "seatReservation.noAssignedSeatsFirstClass"
  }));
};
var NoSeatAssigned_default = NoSeatAssigned;
export {
  NoSeatAssigned_default as default
};
